import { useQuery } from '@tanstack/react-query';
import * as featureApi from '../Api/featureApi';

const FEATURE_LIMITS_KEY = 'features';

/** Fetch all feature limits for a plan — kept separate to avoid circular imports with PlanFeatureAccessContext. */
export const useFeatureLimitsForPlan = (planId) =>
	useQuery({
		queryKey: [FEATURE_LIMITS_KEY, 'limits', planId],
		queryFn: () => featureApi.getFeatureLimitsForPlan(planId),
		enabled: !!planId,
	});
